export default __webpack_public_path__ + "locales/sl/BackupCodesDialog.json?hash=a7f15f6adf6c5314d49fc5da0f1c7d5b";